import { Component, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// Import des services
import { ErrorService } from '../../services/error.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

    @Input() error_message!: string ;
    @Input() error_type!: string;

    constructor(public translate: TranslateService, private errorService: ErrorService) { }

    ngOnInit(): void {
        if (!this.error_message) {
            this.error_message = this.errorService.errorMessage;           
        }

        if (!this.error_type) {
            this.error_type = this.errorService.errorType;
        }
    }

}
